import React from "react";
import { useTranslation } from "react-i18next";
import about3 from "../../assets/images/all-img/aboutUs-section.webp";

const AboutAbt = () => {
  const { t, i18n } = useTranslation(); // Initialize translation

  // Skill progress bars data
  const skills = [
    { key: "business", color: "bg-primary", width: "86%" },
    { key: "marketing", color: "bg-secondary", width: "67%" },
    { key: "design", color: "bg-tertiary", width: "95%" },
  ];

  return (
    <div className="about-area section-padding">
      <div className="container">
        <div className="grid grid-cols-12 gap-[30px]">
          {/* Left Side - Image */}
          <div className="xl:col-span-7 lg:col-span-6 col-span-12">
            <img src={about3} alt="About Online" className="block w-full" />
          </div>
          {/* Right Side - Text & Progress Bars */}
          <div className="xl:col-span-5 lg:col-span-6 col-span-12">
            <div className="mini-title">{t("about_page.mini_title")}</div>
            <h4 className="column-title">
              {t("about_page.title")}{" "}
              {/* <span className="shape-bg">{t("about_page.title")}</span> */}
            </h4>
            <p className="mb-8">{t("about_page.description")}</p>
            {/* Progress Bars */}
            <div className="space-y-8">
              {skills.map((skill, index) => (
                <div className="progressbar-group" key={index}>
                  <div className="flex justify-between">
                    <span className="block text-black font-semibold mb-2">
                      {t(`about_page.skills.${skill.key}`)}
                    </span>
                    <span className="block mb-2 text-black font-semibold">
                      {t(`about_page.percentages.${skill.key}`)}
                    </span>
                  </div>
                  <div className="rounded-[2px] overflow-hidden bg-opacity-10 bg-black h-[6px] relative">
                    <div
                      className={`ani h-[6px] ${skill.color} block absolute  ${
                        i18n.language == "en" ? "left-0" : "right-0"
                      }  top-1/2 -translate-y-1/2`}
                      style={{ width: skill.width }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>{" "}
            {/* End Progress Bars */}
          </div>{" "}
          {/* End Right Side */}
        </div>
      </div>
    </div>
  );
};

export default AboutAbt;
